<template>
  <el-dialog
    top="60px"
    title="贷款申请详情"
    :visible.sync="show"
    width="800px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div class="apply-detail-dialog">
      <el-descriptions
        direction="vertical"
        :column="2"
        size="medium"
        label-style="font-weight: 600; color: #555;"
        content-style="color: #333;"
        class="detail-descriptions"
      >
        <!-- 基本信息 -->
        <el-descriptions-item label="申请产品" prop="productName">
          {{ applyForm.productName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="申请日期" prop="createTime">
          {{ applyForm.createTime || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.companyName"
          label="企业名称"
          prop="companyName"
        >
          {{ applyForm.companyName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.supplyLoanApplyEnterprise"
          label="联系人"
          prop="applicantName"
        >
          {{ applyForm.contactName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="!applyForm.supplyLoanApplyEnterprise"
          label="农户名称"
          prop="applicantName"
        >
          {{ applyForm.contactName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="联系电话" prop="applicantPhone">
          {{ applyForm.contactPhone || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.supplyLoanApplyEnterprise"
          label="企业名称"
          prop="email"
        >
          {{ applyForm.supplyLoanApplyEnterprise.companyName || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.supplyLoanApplyFarmer"
          label="身份证号"
          prop="email"
        >
          {{ applyForm.supplyLoanApplyFarmer.idNumber || '-' }}
        </el-descriptions-item>

        <el-descriptions-item label="注册时间/成立时间" prop="registerDate">
          {{ applyForm.registerDate || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="营业执照" prop="businessLicenseUrl">
          <el-image
            v-if="applyForm.businessLicenseUrl"
            :preview-src-list="[applyForm.businessLicenseUrl]"
            :src="applyForm.businessLicenseUrl"
            fit="contain"
            style="height: 100px; max-width: 200px"
          />
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="身份证正反面" prop="email">
          <div class="id-card-container">
            <el-image
              v-if="applyForm.idCardUrl"
              :preview-src-list="[applyForm.idCardUrl]"
              :src="applyForm.idCardUrl"
              fit="contain"
              style="max-height: 100px"
            />
            <span v-else>-</span>
            <el-image
              v-if="applyForm.idCardNationalUrl"
              :preview-src-list="[applyForm.idCardNationalUrl]"
              :src="applyForm.idCardNationalUrl"
              fit="contain"
              style="max-height: 100px"
            />
            <span v-else>-</span>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="地址" prop="address">
          {{ applyForm.province || '' }}{{ applyForm.city || ''
          }}{{ applyForm.area || '' }}{{ applyForm.address || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.supplyLoanApplyEnterprise"
          label="主要经营业务"
          prop="fundsUses"
        >
          {{ applyForm.fundsUses || '-' }}
        </el-descriptions-item>
        <template v-if="applyForm.supplyLoanApplyFarmer">
          <el-descriptions-item label="营业执照名称" prop="businessLicenseName">
            {{ applyForm.supplyLoanApplyFarmer.businessLicenseName || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="种植面积(亩)" prop="plantArea">
            {{ applyForm.supplyLoanApplyFarmer.plantArea || '-' }}
          </el-descriptions-item>
          <el-descriptions-item label="主要种植品种" prop="plantVarieties">
            {{ applyForm.supplyLoanApplyFarmer.plantVarieties || '-' }}
          </el-descriptions-item>
        </template>
        <el-descriptions-item
          label="年销售收入/上年毛收入(万元)"
          prop="annualIncome"
        >
          {{ applyForm.annualIncome || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="资金需求金额(万元)" prop="fundsAmount">
          {{ applyForm.fundsAmount || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="资金用途" prop="fundsUses">
          {{ applyForm.fundsUses || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="已有银行贷款说明" prop="bankLoanRemark">
          {{ applyForm.bankLoanRemark || '-' }}
        </el-descriptions-item>
        <el-descriptions-item
          v-if="applyForm.supplyLoanApplyEnterprise"
          label="是否有资产抵押"
          prop="assetCollateralRemark"
        >
          {{ applyForm.assetCollateralRemark || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="其他证明材料" prop="pubFileVoList">
          <div
            v-if="applyForm.pubFileVoList && applyForm.pubFileVoList.length > 0"
            class="pub-file-container"
          >
            <el-image
              v-for="item in applyForm.pubFileVoList"
              :key="item.id"
              :preview-src-list="[item.fileUrl]"
              :src="item.fileUrl"
              fit="contain"
              style="height: 100px; width: 100px"
            />
          </div>
          <span v-else>-</span>
        </el-descriptions-item>
        <!-- 审核信息 -->
        <el-descriptions-item label="申请状态" prop="status">
          <el-tag :type="getStatusType(applyForm.status)">{{
            getStatusText(applyForm.status)
          }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="审核时间" prop="approvalTime">
          {{ applyForm.approvalTime || '-' }}
        </el-descriptions-item>
        <el-descriptions-item label="审核意见" prop="auditOpinion" :span="2">
          {{ applyForm.approvalRemark || '-' }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 操作按钮 -->
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关闭</el-button>
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ApplyDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    applyData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false,
      applyForm: {
        // 基本信息
        applyNo: '',
        applyDate: '',
        applicantName: '',
        applicantPhone: '',
        idCardNo: '',
        gender: 1,
        age: 0,
        maritalStatus: 1,
        residentialAddress: '',

        // 贷款信息
        productName: '',
        applyAmount: 0,
        loanTerm: 0,
        applyRate: 0,
        fundPurpose: '',

        // 工作信息
        workUnit: '',
        workYears: 0,
        monthlyIncome: 0,
        position: '',

        // 审核信息
        status: 1,
        auditTime: '',
        auditOpinion: ''
      }
    };
  },
  watch: {
    visible(newVal) {
      this.show = newVal;
      if (newVal && this.applyData) {
        this.applyForm = this.$deepClone(this.applyData);
      }
    },
    applyData: {
      handler(newVal) {
        if (newVal && this.show) {
          this.applyForm = this.$deepClone(newVal);
        }
      },
      deep: true
    }
  },
  methods: {
    // 获取申请状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待审核',
        1: '已通过',
        2: '已拒绝'
      };
      return statusMap[status] || '未知';
    },

    // 获取申请状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || 'info';
    },

    // 审核操作
    handleApproval() {
      this.$emit('approval', this.applyForm);
    },

    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.apply-detail-dialog {
  padding: 10px;
  max-height: 700px;
  overflow: auto;
}

.detail-descriptions {
  margin-bottom: 20px;
}

.detail-descriptions :deep(.el-descriptions__content) {
  word-break: break-word;
}

.dialog-footer {
  text-align: right;
}
.id-card-container {
  display: flex;
  justify-content: space-between;
}
.pub-file-container {
  display: flex;
  flex-wrap: wrap;
  /* align-items: center; */
}
</style>
